export enum PlacementType {
  RIGHT = 'right',
  LEFT = 'left',
}
export interface Position {
  active: PlacementType;
  right: number;
  left: number;
  bottom: number;
}
export enum BackgroundStyleType {
  COLOR = 'color',
  GRADIENT = 'gradient',
}
export enum GradientDirectionType {
  TOP_BOTTOM = 'top_bottom',
  LEFT_RIGHT = 'left_right',
}
export enum ButtonStyleType {
  CLASSIC = 'classic',
  ICON_ONLY_CIRCLE = 'icon_only_circle',
  ICON_ONLY_SQUARE = 'icon_only_square',
  ICON_ONLY_ROUND_TAG = 'icon_only_round_tag',
  ICON_ONLY_SQUARE_TAG = 'icon_only_square_tag',
  ICON_ONLY_DROP_1 = 'icon_only_drop_1',
  TAILOR = 'tailor',
}
export type BubbleMessage = {
  offline?: boolean;
  text: string;
  subtext?: string;
};

export interface ChatCustomization {
  custom_css: string;
  bot_avatar: string;
  front_name: string;
  customer_logo_url: string;
  customer_logo_redirect_link: string;
  contact_forms_header_background_color?: string;
  contact_forms_header_page_template?: string;
  contact_forms_header_radius: number;
  is_open_button_background: boolean;
  is_open_button_icon: boolean;
  is_open_button_shadow: boolean;
  main_color: string;
  panel_color_top: string;
  panel_color_bottom: string;
  panel_close_button_background_color: string;
  panel_close_button_X_color: string;
  on_chat_buttons_radius: number;
  open_bubble_background_color: string;
  open_bubble_background_type: BackgroundStyleType;
  open_bubble_gradient_end: string;
  open_bubble_gradient_start: string;
  open_bubble_gradient_type: GradientDirectionType;
  open_button_background_color: string;
  open_button_font_character: number;
  open_button_font_line: number;
  open_button_font_size: number;
  open_button_icon: string;
  open_button_radius: number;
  open_button_shadow: string;
  open_button_text_color: string;
  secondary_color: string;
  desktop_position: Position;
  mobile_position: Position;
  icon_text_padding: number;
  is_open_button_border: boolean;
  left_side_padding: number;
  // open_button_background_type: BackgroundStyleType;
  open_button_border_color: string;
  open_button_border_width: number;
  open_button_gradient_end: string;
  open_button_gradient_start: string;
  //open_button_gradient_type: GradientDirectionType;
  open_button_icon_height: number;
  // open_button_icon_position: IconPositionType;
  open_button_icon_width: number;
  open_button_action_icon: string;
  open_button_action_icon_width: number;
  open_button_action_icon_height: number;
  open_button_style: ButtonStyleType;
  open_button_text: string;
  open_button_messages: BubbleMessage[];
  open_button_text_alignment: string;
  padding: number;
  right_side_padding: number;
  top_bottom_padding: number;
  tailor_landing_border_radius: number;
  fonts?: {
    fontUrl: string;
    name: string;
    weight: 'regular' | 'semi-bold' | 'medium';
  }[];

  // custom button
  faq_primary_button_radius: number;
  is_faq_primary_button_background: boolean;
  faq_primary_button_background_type: BackgroundStyleType;
  faq_primary_button_gradient_type: GradientDirectionType;
  faq_primary_button_background_color: string;
  faq_primary_button_gradient_start: string | null;
  faq_primary_button_gradient_end: string | null;
  is_faq_primary_button_shadow: boolean;
  faq_primary_button_shadow: string;
  is_faq_primary_button_border: boolean;
  faq_primary_button_border_color: string | null;
  faq_primary_button_border_width: number | null;
  //  Font/Text related
  faq_primary_button_font_size: number;
  faq_primary_button_font_character: number;
  faq_primary_button_font_line: number;
  faq_primary_button_text_color: string;
  faq_primary_button_text_alignment: string;
  //  Icon related
  faq_primary_button_icon_height: number;
  faq_primary_button_icon_width: number;
  faq_primary_button_icon_position: string;
  // Padding related
  faq_primary_button_padding: number;
  faq_primary_button_icon_text_padding: number;
  faq_primary_button_right_side_padding: number;
  faq_primary_button_left_side_padding: number;
  faq_primary_button_top_bottom_padding: number;
  //  FAQ Secondary Button
  // FAQ Button styling and color
  faq_secondary_button_radius: number;
  is_faq_secondary_button_background: boolean;
  faq_secondary_button_background_type: BackgroundStyleType;
  faq_secondary_button_gradient_type: GradientDirectionType;
  faq_secondary_button_background_color: string;
  faq_secondary_button_gradient_start: string | null;
  faq_secondary_button_gradient_end: string | null;
  is_faq_secondary_button_shadow: boolean;
  faq_secondary_button_shadow: string;
  is_faq_secondary_button_border: boolean;
  faq_secondary_button_border_color: string | null;
  faq_secondary_button_border_width: number | null;
  //  Font/Text related
  faq_secondary_button_font_size: number;
  faq_secondary_button_font_character: number;
  faq_secondary_button_font_line: number;
  faq_secondary_button_text_color: string;
  faq_secondary_button_text_alignment: string;
  //  Icon related
  faq_secondary_button_icon_height: number;
  faq_secondary_button_icon_width: number;
  faq_secondary_button_icon_position: string;
  // Padding related
  faq_secondary_button_padding: number;
  faq_secondary_button_icon_text_padding: number;
  faq_secondary_button_right_side_padding: number;
  faq_secondary_button_left_side_padding: number;
  faq_secondary_button_top_bottom_padding: number;

  // FAQ Disabled Button
  faq_disabled_button_radius: number;
  is_faq_disabled_button_background: boolean;
  faq_disabled_button_background_type: BackgroundStyleType;
  faq_disabled_button_gradient_type: GradientDirectionType;
  faq_disabled_button_background_color: string;
  faq_disabled_button_gradient_end: string | null;
  faq_disabled_button_gradient_start: string | null;
  is_faq_disabled_button_shadow: boolean;
  faq_disabled_button_shadow: string;
  is_faq_disabled_button_border: boolean;
  faq_disabled_button_border_color: string | null;
  faq_disabled_button_border_width: number | null;
  //  Font/Text related
  faq_disabled_button_font_size: number;
  faq_disabled_button_font_character: number;
  faq_disabled_button_font_line: number;
  faq_disabled_button_text_color: string;
  faq_disabled_button_text_alignment: string;
  //  Icon related
  faq_disabled_button_icon_height: number;
  faq_disabled_button_icon_width: number;
  faq_disabled_button_icon_position: string;
  // Padding related
  faq_disabled_button_padding: number;
  faq_disabled_button_icon_text_padding: number;
  faq_disabled_button_right_side_padding: number;
  faq_disabled_button_left_side_padding: number;
  faq_disabled_button_top_bottom_padding: number;

  // NBR settings
  auto_collapse: boolean;
  delay_before_collapse: number;
  delay_before_show: number;
  open_nba_button_background_color: string;
  open_nba_button_icon: string;

  // Close button
  close_button_icon: string;
  close_button_icon_height: number;
  close_button_icon_width: number;
  close_button_background_color: string;

  fe_config: {
    typography?: {
      sectionHeader?: {
        color?: string;
        fontSize?: number;
      };
    };
    virtualAssistant?: {
      showErrorMessage?: boolean;
      options?: {
        optionBackgroundColor?: string;
        selectedOptionBackgroundColor?: string;
      };
    };
    pills?: {
      borderColor?: string;
      hoverBorderColor?: string;
    };
    v40UnityOverrides?: {
      useUnitySearchBar?: boolean;
      useUnitySearchResultIcon?: boolean;
    };
  };
}
